<template>
  <div class="col-12 h-100 common-card">
    <div class="chart-wrapper">
      <div class="common-card__title">
        <h2>금일 발전량 (Wh)</h2>
      </div>

      <!-- ① 날씨 레이어 (plot-area 위에 절대 위치) -->
      <div class="weather-row" ref="weatherRow">
        <div
          v-for="(w, i) in weatherData"
          :key="i"
          class="weather-cell"
        >
          <img class="weather-icon" v-if="w.icon && w.icon.includes('.png')" :src="w.icon" alt="맑음" width="40" height="40" />

          <div class="weather-icon" v-else :style="{display: 'flex', alignItems: 'center', justifyContent: 'center', placeSelf: 'center'}">
            <span>-</span>
          </div>
          <div class="temp">{{ w.temp ? w.temp :'-' }}℃</div>
          <div class="hum">{{ w.hum ? w.hum : '-' }}%</div>
        </div>
      </div>

      <!-- ② ApexCharts 차트 -->
      <apexchart
        id="gen-chart"
        chart-id="gen-chart"
        ref="chartRef"
        type="line"
        :height="'80%'"
        :options="options"
        :series="series"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, nextTick } from 'vue'
import sunIcon from '/weatherIcons/day_dry.png';
import moment from 'moment';
import { useTocStore } from '~/store/tocStore';


const props = defineProps<{
  apiData?: any,
  pageType?: string
}>()


const siteData = computed(() => tocStore.selectSiteInfo);

const tocStore = useTocStore();


const originWeatherData = ref();
// 날씨 데이터 (전부 동일 예시)
const weatherData = ref([]);
const chartRef = ref(null)
const weatherRow = ref<HTMLElement | null>(null)

// 예시 데이터 (실사용 값으로 교체)
const prodData   = ref([])
const sunData    = ref([])
const lineGreen  = ref([])



// 2시간 간격 13개 카테고리
const categories = ref([

]);

// ③ 시리즈 정의
const series = computed(() => {
  return [
  { name: '발전량(W)',
    type: 'bar',
    data: prodData.value
  },
  { name: '일사량', type: 'line', data: sunData.value },
  // { name: '출력제어률', type: 'line', data: lineGreen.value}
  ]
})


async function getProdData(){
  // const res = await tocStore.getWeatherData(undefined, siteData.value.dongCode as string);
  // barData.value = res.chartData.map((v: any) => v.values[0]);
  // lineBlue.value = res.chartData.map((v: any) => v.values[3]);
  // lineGreen.value = res.chartData.map((v: any) => v.values[4]);

  console.log("title: 금일 발전량", props.apiData);
  originWeatherData.value = [];
  categories.value = [];

  if(props.apiData) {
    originWeatherData.value = props.apiData.weather.map((v:any) => {return {date: moment(v.fcstDate).format('YYYY-MM-DD HH'), icon: v.iconPath, temp: v.temp, hum: v.humidity }})
    categories.value = props.apiData.chartData.map(v => `${moment(v.dateTime).format('HH')}시`);
  }

  if(originWeatherData.value.length < categories.value.length) {
    for(let i = originWeatherData.value.length; i < categories.value.length; i++){
      originWeatherData.value.push({date: moment(categories.value[i]).format('YYYY-MM-DD HH'), icon: null, temp: null, hum: null});
    }
  }

  for(let i = 0; i < originWeatherData.value.length; i++){
    if(i % 3 !== 0) continue;
    weatherData.value.push(originWeatherData.value[i]);
  }

  console.log(weatherData.value);

  
  // chartData와 originWeatherData가 props에 정의되어 있지 않으므로, props.apiData에서 직접 값을 추출하도록 수정
  if (props.apiData && Array.isArray(props.apiData.chartData)) {
    prodData.value = props.apiData.chartData.map((v: any) => v.values[0] ? Number((v.values[0] * 1000).toFixed(1)) : null);
  } else {
    prodData.value = [];
  }


  if (props.apiData && Array.isArray(props.apiData.weather)) {
    sunData.value = props.apiData.weather.map((v: any) => v.solarRadAmt);
  } else {
    sunData.value = [];
  }

  if(prodData.value.length < sunData.value.length){
    for(let i = prodData.value.length; i < sunData.value.length; i++){
      prodData.value.push(null);
    }
  }

}


const y1maxBar = computed(() => Math.max(...prodData.value))
const y2maxBar = computed(() => Math.max(...sunData.value))

const y1bufferedMax = computed(() => Math.ceil(y1maxBar.value * 1.1))  // 10% 여유
const y2bufferedMax = computed(() => Math.ceil(y2maxBar.value * 1.1))  // 10% 여유


// ④ 옵션 정의 (v3.46.0 기준)
const options = computed(() => {return {
  chart: {
    id: 'gen-chart',
    toolbar: { show: false },
    // background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(240, 177, 20, 0.24) 100%)',
    events: {
      // 렌더링 직후, 리사이즈 후에 날씨 정렬 스크립트 실행
      mounted:  (ctx) => { alignWeather(); applyGridGradient(ctx) },
      updated:  (ctx) => { alignWeather(); applyGridGradient(ctx) },
      animationEnd: (ctx) => { alignWeather(); applyGridGradient(ctx) }
    }
  },
  plotOptions: {
    bar: { 
      borderRadius: 4, 
      columnWidth: '50%', 
      borderRadiusApplication: 'end',
    }
  },
  legend: {
    show: false,
  },
  tooltip: {
    shared: true,
    intersect: false,
    valueFormatter: (value: number) => {
      if(value === null) return '-';
      return commonUtils.numberWithCommas(value, 0)
    }
  },
  stroke: { width: [0, 3, 3] },
  markers: { size: [0, 0, 0], shape: 'circle' },
  dataLabels: { enabled: false },
  grid: {
    padding:{top: 35, right: 0, bottom: 0, left: 0},
    borderColor: '#a3a3a3',
    strokeDashArray: 4,
    xaxis: { lines: { show: true } },
    yaxis: { lines: { show: false } }
  },
  xaxis: {
    categories: categories.value,
    tickPlacement: 'between',
    axisBorder: { show: false },
    axisTicks: { show: false },
    labels: {
      hideOverlappingLabels: true,
      rotateAlways: false,
      rotate: 0,
      style: {
				fontSize: "8px",
			  fontWeight: 700
			}
    }
  },
  yaxis: [
    // NOTE: 발전량 그래프
    {
      decimalsInFloat: 0,
      // title: { text: '발전량', style: { color: '#FB8C00' } },
      labels: { style: { colors: '#0687f1' }, offsetX: -10,
      formatter: (value: number) => {
        if(value === 0) return value;
          if(value === null || value === undefined) return '-';
          return commonUtils.numberWithCommas(value, 0)
        }
      },
      max: y1bufferedMax.value * 1.3,
      min: 0
    },
    // NOTE: 일사량 그래프
    {
      decimalsInFloat: 0,
      opposite: true,
      // title: { text: '%', style: { color: '#0687f1' } },
      labels: { style: { colors: '#FB8C00' }, offsetX: -10, formatter: (value: number) => {

        if(value === 0) return value;
          if(value === null) return '-';
          return commonUtils.numberWithCommas(value, 0)
        }},
      max: y2bufferedMax.value * 1.3,
      min: 0,
    }
  ],
  colors: ['#0687f1', '#FB8C00'],
}});

// 1) 컴포넌트가 처음 마운트될 때
onMounted(() => {
  nextTick(async () => {
    await getProdData();
    alignWeather();

  });
})



// 2) 리액티브 데이터(옵션/시리즈 등) 변경으로 컴포넌트가 업데이트될 때
onUpdated(() => {
  alignWeather()
})

// 3) 컴포넌트 언마운트 시 반드시 리스너 제거
onBeforeUnmount(() => {
})

/** 날씨 셀을 x축 중앙에 놓는 함수 **/
function alignWeather() {

  const comp = chartRef.value
  const row  = weatherRow.value
  if (!comp || !row) return

  // 내부 globals 가져오기
  const apex = (comp as any).chart
  const { translateX, gridWidth } = apex.w.globals
  // tickPlacement: 'between' 이므로 N 분할
  const N    = categories.value.length
  const step = gridWidth * 3 / N 
  const base = translateX + step/2

  // wrapper 전체 가로 덮기
  row.style.left  = '0'
  row.style.width = '100%'

  // 각 셀을 absolute 배치
  Array.from(row.children).forEach((child,i) => {

    const cell = child as HTMLElement
    cell.style.position  = 'absolute'
    cell.style.top       = '0'
    cell.style.width     = `${gridWidth * 3 / N}px`
    cell.style.left      = `${base + step * i}px`
    cell.style.transform = 'translateX(-50%)'
    // TODO: cell.style.borderBottom = '2px solid #F28F51'

    // const icon = cell.querySelector('.weather-icon')
    // icon.style.width = `${step * 0.5}px`
    // icon.style.height = `${step * 0.5}px`

  })
}

// ⑥ 그라디언트 Rect 삽입 · 채우기
function applyGridGradient(chartCtx: any) {
  const svgNS = 'http://www.w3.org/2000/svg'
  const svg   = chartCtx.el.querySelector('svg')
  if (!svg) return

  // defs & gradient 정의 (한 번만)
  let defs = svg.querySelector('defs')
  if (!defs) {
    defs = document.createElementNS(svgNS, 'defs')
    svg.prepend(defs)
  }
  let grad = defs.querySelector('#gridGradient')
  if (!grad) {
    grad = document.createElementNS(svgNS, 'linearGradient')
    grad.setAttribute('id','gridGradient')
    grad.setAttribute('x1','0%'); grad.setAttribute('y1','0%')
    grad.setAttribute('x2','0%'); grad.setAttribute('y2','100%');
    
    // NOTE: 그래프 background 색상
    [
      { offset: '0%', color: '#FFF', opacity: 0.2 },
      { offset: '100%', color: '#FFF', opacity: 0 }
    ].forEach(s => {
      const stopEl = document.createElementNS(svgNS,'stop');

      stopEl.setAttribute('offset', s.offset);
      stopEl.setAttribute('stop-color', s.color);
      stopEl.setAttribute('stop-opacity', String(s.opacity));
      grad!.appendChild(stopEl);
    })
    defs.appendChild(grad)
  }

  // plot-area 위치·크기
  const apex = chartRef.value?.chart;
  const { translateX, translateY, gridWidth, gridHeight } = apex.w.globals

  // rect 삽입(한 번만) 및 속성 갱신
  let rect = svg.querySelector('#gridGradientRect')
  if (!rect) {
    rect = document.createElementNS(svgNS,'rect')
    rect.setAttribute('id','gridGradientRect')
    rect.setAttribute('fill','url(#gridGradient)')
    // grid lines 그룹 바로 앞에 삽입 → grid 뒷배경
    const gridG = svg.querySelector('.apexcharts-grid')
    gridG?.parentNode?.insertBefore(rect, gridG)
  }
  rect.setAttribute('x',      `0`)
  rect.setAttribute('y',      `0`)
  rect.setAttribute('width',  `${gridWidth}`)
  rect.setAttribute('height', `${gridHeight}`)
}
</script>
<style lang="scss" scoped>
@use "@/assets/styles/design-toc/define_font.scss";
@use "@/assets/styles/design-toc/common-card.scss";
@import "@/assets/styles/design-toc/weather-prod-chart.scss";

.common-card {
  padding: 0.5rem 1rem !important;

  &__title {
    margin-bottom: 10px;
    h2 {
      line-height: 150%;
    }
  }
}
</style>